import { useController } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import { FormControlLabel, Switch } from "@mui/material";

export function MiControlledSwitch({
  name,
  control,
  label = "",
  handleChange,
  value,
  disabled = false,
  readOnly = false,
}) {
  const {
    field: { value: defaultValue, onChange, onBlur, ref },
  } = useController({ name, control });
  const { classes } = useStyles();

  return (
    <FormControlLabel
      className={classes.switch}
      control={
        <Switch
          checked={value ?? defaultValue}
          onChange={handleChange || onChange}
          onBlur={onBlur}
          inputRef={ref}
          inputProps={{ "data-testid": `mi-switch-${name}`, readOnly }}
          disabled={disabled}
          readOnly={readOnly}
        />
      }
      label={label}
    />
  );
}

const useStyles = makeStyles()(() => ({
  switch: { width: "100%", margin: 0 },
}));
